import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const UserIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M2.69727 16.25C3.80177 14.4077 6.2225 13.1468 9.99916 13.1468C13.7758 13.1468 16.1966 14.4077 17.3011 16.25M12.9992 6.75C12.9992 8.40685 11.656 9.75 9.99916 9.75C8.34231 9.75 6.99916 8.40685 6.99916 6.75C6.99916 5.09315 8.34231 3.75 9.99916 3.75C11.656 3.75 12.9992 5.09315 12.9992 6.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </BaseIcon>
  );
};

UserIcon.displayName = 'UserIcon';
